import { FormControlLabel, FormHelperText, Grid, Switch } from "@mui/material";
import { MprcContainer } from "components/MprcContainer";
import { UserEditProfileResponse, UserPhoneTypeSelectorResponse } from "generated/CoreApi_v1";
import { useSession } from "providers/SessionProvider";
import React from "react";
import { useTranslation } from "react-i18next";
////////////////////////////////////////////////////////////////////////////

export interface IPostValidation {
    customFields: { [key: string]: string[] | undefined; };
}

interface IProps {
    viewData: UserEditProfileResponse;
    viewErrors: ApiProblemErrors | undefined;
    phoneTypeItems: UserPhoneTypeSelectorResponse[];
    onFormUpdate: (dto: UserEditProfileResponse) => void;
}

////////////////////////////////////////////////////////////////////////////

/**
 * Edição do Perfil do Usuário - Preferências
 * @param props
 */
export const EditUserPreferencesBox: React.FC<IProps> = (props) => {
    ///////////////////////////////////////////////////////////////////////////

    const { t } = useTranslation();
    const session = useSession();
    const { viewData, onFormUpdate } = props;

    const isSelfUser = viewData.userId == session.user.userId;

    ////////////////////////////////////////////////////////////////////////////
    ///
    const handleUpdateRecord = (name: keyof UserEditProfileResponse, v: any) => {
        onFormUpdate({ ...viewData, [name]: v });
    };

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <>
            <MprcContainer>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12 }}>
                        <FormControlLabel
                            label={t("User.Edit.DiscloseBirthDateSubTitle")}
                            control={
                                <Switch
                                    checked={viewData.discloseBirthDate ?? false}
                                    onChange={(e) => handleUpdateRecord("discloseBirthDate", e.target.checked)}
                                />
                            }
                            disabled={!isSelfUser}
                        />
                        <FormHelperText component="div" sx={{ mt: 0 }}>
                            <ul style={{ paddingLeft: 58, marginTop: 0, marginBottom: 0 }}>
                                <li>{t("User.Edit.Preferences.DiscloseBirthL1")}</li>
                                <li>{t("User.Edit.Preferences.DiscloseBirthL2")}</li>
                            </ul>
                        </FormHelperText>
                    </Grid>
                </Grid>
            </MprcContainer>
        </>
    );
};
